import classNames from 'classnames'
import { JSX } from 'react'

import { IRichTextEditorProps, RichTextEditor } from 'core-components/library/richTextEditor'
import themesStyles from 'onboarding/components/themes.module.scss'

type TComponentFn = (props: IRichTextEditorProps) => JSX.Element

const applyDisabled = (component: TComponentFn) => {
  return (props: IRichTextEditorProps) => {
    const { disabled, classes } = props
    const disabledTheme = disabled ? themesStyles.disabledInput : undefined

    return component({
      ...props,
      classes: {
        ...classes,
        root: classNames(classes?.root, disabledTheme),
      },
    })
  }
}

const RichTextEditorFn = (props: IRichTextEditorProps) => <RichTextEditor {...props} />

export const OnboardingRichTextEditor = (props: IRichTextEditorProps) =>
  applyDisabled(RichTextEditorFn)(props)
